import React from "react";
import { Alert, Box, Button, Divider, Typography } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  StyledDialogActions,
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
} from "../../../../../platform/assets/css/styledComponent";

const DeleteConfirmationStyledDialog = ({
  open,
  staffName,
  handleClose,
  handleDelete,
}) => (
  <StyledDialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
    <StyledDialogTitle sx={{ pb: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberRoundedIcon color="warning" fontSize="small" />
        <span>Delete Staff Profile</span>
      </Box>
    </StyledDialogTitle>
    <StyledDialogContent>
      <Typography sx={{ mb: 1.25 }}>
        You are about to delete{" "}
        <Box component="span" sx={{ fontWeight: 800 }}>
          {staffName || "this staff member"}
        </Box>
        .
      </Typography>
      <Alert severity="warning" variant="outlined" sx={{ mb: 0.75 }}>
        This action cannot be undone.
      </Alert>
      <Typography variant="body2" color="text.secondary">
        Related assignments and access may be affected after deletion.
      </Typography>
    </StyledDialogContent>
    <Divider />
    <StyledDialogActions>
      <Button onClick={handleClose} variant="outlined">
        Keep Staff
      </Button>
      <Button onClick={handleDelete} color="error" variant="contained">
        Delete Staff
      </Button>
    </StyledDialogActions>
  </StyledDialog>
);

export default DeleteConfirmationStyledDialog;
